import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useGetRoomSystem } from "@/features/room-systems/api/get-room-system";
import { RoomSystemForm } from "@/features/room-systems/components/room-system.form";

export function RoomSystem() {
  const { id } = useParams<{ id: string }>();
  const {
    data: roomSystem,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetRoomSystem({ id: id ?? "" });

  const ReturnButton = () => (
    <Button variant="ghost" asChild className="mb-6 self-start">
      <Link to="/admin/room-systems">
        <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
        Return to Room Systems
      </Link>
    </Button>
  );
  if (isLoading)
    return (
      <div>
        <ReturnButton />
        <OnboardingHeader title="Edit Room System" className="mb-6" />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <ReturnButton />
        <OnboardingHeader title="Edit Room System" className="mb-6" />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <section>
      <ReturnButton />
      <OnboardingHeader title="Edit Room System" className="mb-6" />
      <RoomSystemForm initialData={roomSystem} />
    </section>
  );
}
